import { Icon } from '@zillow/constellation-10';
import { IconUserFilled } from '@zillow/constellation-icons';

import EmptyState from '../../EmptyState';

const heading = 'No tenants added yet';
const body = 'Keep track of who’s living in your rental, what their lease terms are, and how to reach them.';

const EmptyTenantsCard = () => {
  return (
    <EmptyState
      data-testid="EmptyTenantsCard"
      icon={<Icon size="md" css={{ color: 'icon.subtle' }} render={<IconUserFilled />} />}
      heading={heading}
      body={body}
    />
  );
};

export default EmptyTenantsCard;
